import { dsClass } from '../../../common/constants/dsClasses.js';
import { internetConnectionMsg, t } from '../../../common/i18n/index.js';
import { OfferSpecifications } from '../../HorizontalSubscriptionCard/OfferSpecifications.js';
import { getDefaultModalSpecifications } from '../../ProductOfferingsCardCoCo/ProductOfferingsCardContentCoCo/ProductOfferingCardContentUtils.js';
import type { ProductModalContentProps } from '../../ProductOfferingsCardCoCo/ProductOfferingsCardContentCoCo/types.js';

export const getFixedBroadbandModalContent = ({ productOffering, activePopoverRef }: ProductModalContentProps) => {
  const modalSpecs = getDefaultModalSpecifications(productOffering);

  return [
    {
      title: t.B10B(internetConnectionMsg),
      content: (
        <OfferSpecifications specifications={modalSpecs.voiceAndTextSpecs} activePopoverRef={activePopoverRef} />
      ),
    },
    ...(modalSpecs.has5gPlus
      ? [
          {
            title: '5G+',
            content: (
              <p className={dsClass.TEXT_XS}>
                {t.A504(
                  `5G+ subscriptions always use the best available connection. In areas without 5G coverage, they switch to 4G network instead. Using a 5G+ subscription can cut delay times by half. The new 5G+ technology also saves your phone's battery, which makes it a more energy-efficient option.`
                )}
              </p>
            ),
          },
        ]
      : []),
  ];
};
